import React, { Component } from 'react'
import ErrorPage from 'common/components/ErrorPage'
import { getResourceCity } from 'common/admin/operations'

/**
 * Wraps a component which has a urlResource prop. Queries the API for the
 * resource's city, and then forwards the urlResource prop with a new `timezone`
 * property. Note that this HOC should be applied *after* withUrlResource.
 *
 * Usage:
 *
 *    const MyComponent = ({ urlResource }) => { return urlResource.timezone }
 *
 *    compose(
 *      withUrlResource,
 *      withUrlResourceTimezone
 *    )
 */

export default (WrappedComponent) => {
  return class extends Component {
    state = {
      error: null,
      city: null,
      loaded: false
    }

    async componentDidMount () {
      const { urlResource } = this.props

      try {
        const city = await getResourceCity(urlResource.plural, urlResource.id)
        this.setState({ city, loaded: true })
      } catch (error) {
        this.setState({ error, loaded: true })
      }
    }

    render () {
      const { loaded, error, city } = this.state
      const { urlResource, ...rest } = this.props

      if (!loaded) return null
      if (error) return <ErrorPage />

      const urlResourceWithTimezone = { ...urlResource, timezone: city.timezone_name }
      return <WrappedComponent urlResource={urlResourceWithTimezone} {...rest} />
    }
  }
}
